import { serviceActionsGenerator } from '../serviceGenerator'

const actionTypes = ['!FETCH_COMPANY_DOCUMENTS', '!REMOVE_COMPANY_DOCUMENT', '!UPLOAD_COMPANY_DOCUMENTS'] as const

export default serviceActionsGenerator('companyDocuments', actionTypes)
